const SVGComponent = ({ color = "#000000" }) => (
  <svg width={21} height={20} viewBox="0 0 21 20" fill="none">
    <path
      d="M9.35856 9.1665H10.4002L10.4002 13.5415M18.1086 9.99984C18.1086 14.257 14.6574 17.7082 10.4002 17.7082C6.14303 17.7082 2.69189 14.257 2.69189 9.99984C2.69189 5.74264 6.14303 2.2915 10.4002 2.2915C14.6574 2.2915 18.1086 5.74264 18.1086 9.99984Z"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4009 6.125C10.6999 6.12518 10.9419 6.36795 10.9419 6.66699C10.9417 6.96589 10.6998 7.20783 10.4009 7.20801C10.1018 7.20801 9.85906 6.966 9.85889 6.66699C9.85889 6.36784 10.1017 6.125 10.4009 6.125Z"
      fill={color}
      stroke={color}
      strokeWidth={0.25}
    />
  </svg>
)
export default SVGComponent
